<template>
  <div class="container">
    <!-- 탭메뉴 -->
    <tabMenu />

    <!-- 자산현황 페이지 콘텐츠 -->
    <div>
      <!-- 요약박스 -->
      <div class="summary-wrap">
        <!-- 요약박스 : 상위 콘텐츠 -->
        <div class="top-content">
          <!-- 총 보유자산 -->
          <div class="totalAsset">
            <div class="content" flex>
              <div class="title">
                <p>{{ $t("RateToReturn.totalAssets") }}</p>
              </div>
              <!-- 원화 환산 추정값 안내 -->
              <div class="toKRW-noti" @click="showToKRWPopup">
                <p>
                  {{ $t("RateToReturn.tooltip.estimatesOfWonConversion") }}
                </p>
                <div class="icon"></div>
              </div>
            </div>
            <div class="data">
              <span class="txt-bold">
                {{ parseInt(totalWallet) | formatNumber4 }}
              </span>
              <span class="txt-normal">{{ $t("RateToReturn.won") }}</span>
            </div>
          </div>
          <!-- 총 평가수익률 -->
          <div flex>
            <div class="value bold" :class="totalRatioProfitLosses | rbClass">
              <i class="el-icon-caret-top" v-if="totalRatioProfitLosses > 0" />
              <i class="el-icon-caret-bottom" v-else />
              {{ totalRatioProfitLosses | formatNumber5(2) }}% ({{
                parseInt(totalProfitLosses) | formatNumber6
              }})
            </div>
          </div>
        </div>
        <!-- 보유 KRW -->
        <div
          class="summary-total krw"
          flex
          fjb
          v-if="filterWallet.length && parseInt(filterWallet[0].available) > 0"
        >
          <div class="key">{{ $t("RateToReturn.KRWHeld") }}</div>
          <div class="value">
            {{
              !filterWallet.length
                ? 0
                : parseInt(filterWallet[0].available) | formatNumber4
            }}
            {{ $t("RateToReturn.won") }}
          </div>
        </div>
        <!-- 요약박스 : 하위 콘텐츠 -->
        <div class="bottom-content" flex>
          <!-- 총 평가금액 -->
          <div class="summary-total">
            <div class="key">{{ $t("RateToReturn.virtualAssetsHeld") }}</div>
            <div class="value">
              {{ parseInt(totalPriceProfiLosses) | formatNumber4 }}
            </div>
          </div>
          <!-- 총 매수금액 -->
          <div class="summary-total">
            <div class="key">{{ $t("RateToReturn.totalPurchaseAmount") }}</div>
            <div class="value">
              {{
                !filterWallet.length
                  ? 0
                  : parseInt(totalBuyingPrice) | formatNumber4
              }}
            </div>
          </div>
        </div>
        <!-- 요약박스 : 보유 KRW, 총 평가금액, 총 매수금액 -->
        <div class="bottom"></div>
      </div>
      <!-- 자산내역 -->
      <div class="detail-wrap">
        <!-- 소액자산 숨기기 -->
        <div class="smallballance-type01 check-box">
          <el-checkbox
            :value="getSmallBalance"
            @change="setSmallBalance"
            v-model="checked"
            >{{ $t("RateToReturn.hideSmallAssets") }}</el-checkbox
          >
        </div>
        <!-- 자산내역 : 리스트 -->
        <div class="list-wrap">
          <!-- 자산내역 없을 때 -->
          <div v-if="!filterWallet.length" class="ta-c pt50">
            {{ $t("RateToReturn.noAssetsDetails") }}
          </div>
          <div v-else>
            <div
              v-for="(asset, index) in filterWallet"
              :key="index"
              class="list"
              :class="
                (toKRW(asset.coin.code).price * asset.total)
                  | hiddenClass(checked)
              "
            >
              <div
                v-if="asset.coin.code != 'KRW' && asset.total > 0"
                class="content-box"
              >
                <div class="detail-content top" flex>
                  <!-- 보유코인 -->
                  <div v-if="asset.avail.USDT == true" class="left-content">
                    <router-link :to="`/trade/USDT/${asset.coin.code}`">
                      <img
                        :src="
                          `https://static.flybit.com/static/img/mobile/coin_${asset.coin.code}.png`
                        "
                        :alt="`${asset.coin.code} 코인 심볼`"
                        class="coin-symbol"
                      />
                      <span v-if="$i18n.locale === 'ko'">
                        {{ asset.coin.name }} {{ asset.coin.code }}
                        &nbsp;&nbsp;
                        <img
                          src="../../assets/img/common/arrow-right.svg"
                          alt=""
                          class="icon-link"
                        />
                      </span>
                      <span v-else>
                        {{ asset.coin.code }}
                        &nbsp;&nbsp;
                        <img
                          src="../../assets/img/common/arrow-right.svg"
                          alt=""
                          class="icon-link"
                      /></span>
                    </router-link>
                  </div>
                  <div v-else class="left-content">
                    <img
                      :src="
                        `https://static.flybit.com/static/img/mobile/coin_${asset.coin.code}.png`
                      "
                      :alt="`${asset.coin.code} 코인 심볼`"
                      class="coin-symbol"
                    />
                    <span v-if="$i18n.locale === 'ko'">
                      {{ asset.coin.name }} {{ asset.coin.code }}
                      &nbsp;&nbsp;
                      <img
                        src="../../assets/img/common/arrow-right.svg"
                        alt=""
                        class="icon-link"
                      />
                    </span>
                    <span v-else>
                      {{ asset.coin.code }}
                      &nbsp;&nbsp;
                      <img
                        src="../../assets/img/common/arrow-right.svg"
                        alt=""
                        class="icon-link"
                      />
                    </span>
                  </div>
                  <!-- // 보유코인 -->

                  <!-- 평가손익 -->
                  <div class="right-content">
                    <!-- 평가손익(%) -->
                    <div
                      v-if="
                        checkOnViewEnable(asset.coin.code) ||
                          asset.wAvgPrice == 0
                      "
                      class="ratio"
                    >
                      0 %
                    </div>
                    <div
                      v-else
                      class="ratio"
                      :class="
                        (toKRW(asset.coin.code).price * asset.total -
                          asset.total * asset.wAvgPrice)
                          | rbClass
                      "
                    >
                      {{
                        (((toKRW(asset.coin.code).price * asset.total) /
                          (asset.total * asset.wAvgPrice) -
                          1) *
                          100)
                          | formatNumber5(2)
                      }}
                      %
                    </div>
                    <!-- // 평가손익(%) -->
                    <!-- 평가손익(KRW) -->
                    <div
                      v-if="
                        checkOnViewEnable(asset.coin.code) ||
                          asset.wAvgPrice == 0
                      "
                      class="ratio"
                    >
                      0 KRW
                    </div>
                    <div
                      v-else
                      class="priceToKRT"
                      :class="
                        (toKRW(asset.coin.code).price * asset.total -
                          asset.total * asset.wAvgPrice)
                          | rbClass
                      "
                    >
                      {{
                        (Math.floor(
                          asset.total * toKRW(asset.coin.code).price
                        ) -
                          Math.floor(asset.total * asset.wAvgPrice))
                          | formatNumber6
                      }}
                      KRW
                    </div>
                  </div>
                  <!-- 평가손익(KRW) -->
                </div>
                <div class="detail-content">
                  <!-- 평가손익 -->
                  <div class="bottom-content" flex>
                    <!-- 보유수량 -->
                    <div class="summary-total">
                      <div class="key">
                        {{ $t("RateToReturn.menu.name[1]") }}
                      </div>
                      <div class="value">
                        {{ asset.total | formatNumber2(8) }}
                        <span class="bold">{{ asset.coin.code }}</span>
                      </div>
                    </div>
                    <!-- 매수평균가 -->
                    <div class="summary-total">
                      <div class="key">
                        {{ $t("RateToReturn.menu.name[2]") }}
                      </div>
                      <div
                        class="value"
                        v-if="checkOnViewEnable(asset.coin.code)"
                      >
                        {{ "-" }}
                      </div>
                      <div class="value" v-else>
                        {{ asset.wAvgPrice | formatNumber2(2) }}
                        <span class="bold">KRW</span>
                      </div>
                    </div>
                  </div>
                  <!-- // 매수평균가 -->
                  <div class="bottom-content mt10" flex>
                    <!-- 매수금액 -->
                    <div class="summary-total">
                      <div class="key">
                        {{ $t("RateToReturn.menu.name[3]") }}
                      </div>
                      <div
                        class="value"
                        v-if="checkOnViewEnable(asset.coin.code)"
                      >
                        {{ "-" }}
                      </div>
                      <div class="value" v-else>
                        {{
                          parseInt(asset.total * asset.wAvgPrice)
                            | formatNumber4
                        }}
                        <span class="bold">KRW</span>
                      </div>
                    </div>
                    <!-- // 매수금액 -->
                    <!-- 평가금액 -->
                    <div class="summary-total">
                      <div class="key">
                        {{ $t("RateToReturn.menu.name[4]") }}
                      </div>
                      <div
                        class="value"
                        v-if="checkOnViewEnable(asset.coin.code)"
                      >
                        {{ "-" }}
                      </div>
                      <div class="value" v-else>
                        {{
                          parseInt(asset.total * toKRW(asset.coin.code).price)
                            | formatNumber4
                        }}
                        <span class="bold">KRW</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 툴팁 / 팝업 -->
      <vs-popup
        :title="$t('RateToReturn.tooltip.estimatesOfWonConversion')"
        :active.sync="popupToKRW"
        :button-close-hidden="true"
        class="member-popup"
      >
        <!-- 팝업 내용 -->
        <div class="text-wrap">
          <div class="text-detail">
            <div>
              {{ $t("RateToReturn.tooltip.contentsTitle[0]") }}
            </div>
            <div class="mt10">
              {{ $t("RateToReturn.tooltip.contentsTitle[1]") }}
            </div>
            <div class="mt10">
              {{ $t("RateToReturn.tooltip.contentsTitle[2]") }}
            </div>
            <div class="title" v-html="$t('RateToReturn.tooltip.detail')"></div>
            <div class="mt10">
              {{ $t("RateToReturn.tooltip.contentsTitle[3]") }}
              <span class="detail">
                {{ $t("RateToReturn.tooltip.contentsTitle[4]") }}
              </span>
            </div>
            <div class="mt10">
              {{ $t("RateToReturn.tooltip.contentsTitle[5]") }}
            </div>
          </div>
        </div>
        <!-- 닫기 버튼 -->
        <div class="button-wrap">
          <vs-button
            color="danger"
            type="border"
            @click="closeToKRWPopup"
            class="btn-block"
            >{{ $t("confirm.ok") }}</vs-button
          >
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import Decimal from "decimal.js";
import TabMenu from "@/components/investments/tabMenu";

export default {
  data() {
    return {
      popupToKRW: false,
      checked: true,
      totalBuyingPrice: 0,
      imgsrc: `//static.flybit.com/static/img/mobile/coin_`,
    };
  },
  computed: {
    ...mapGetters([
      "marketsByBaseCoinCode",
      "toKRW",
      "wallet",
      "totalAssetToKRW",
      "marketsByCode",
      "getSmallBalance",
      "coinSettings",
      "walletByCoinName",
      "currencySettings",
      "pend",
      "getSmallBalance",
    ]),
    // 총 평가수익률
    totalRatioProfitLosses() {
      return (this.totalProfitLosses / this.totalBuyingPrice) * 100;
    },

    // 총 평가손익금액
    totalProfitLosses() {
      return (
        Math.floor(this.totalPriceProfiLosses) -
        Math.floor(this.totalBuyingPrice)
      );
    },
    // 총 평가금액
    totalPriceProfiLosses() {
      if (!this.filterWallet.length) {
        return 0;
      }
      return this.filterWallet
        .map((ele, index) =>
          index != 0 ? this.toKRW(ele.coin.code).price * ele.total || 0 : 0
        )
        .reduce((acc, cur) => acc + cur);
    },
    //총 사용가능 금액
    totalAvailable() {
      if (!this.filterWallet.length) {
        return 0;
      }
      return this.filterWallet
        .map((ele) => this.toKRW(ele.coin.code).price * ele.available || 0)
        .reduce((acc, cur) => acc + cur);
    },
    // 자산내역 리스트 메뉴
    RateToReturn() {
      return {
        menu: [
          { name: this.$t("RateToReturn.menu.name[0]") },
          { name: this.$t("RateToReturn.menu.name[1]") },
          { name: this.$t("RateToReturn.menu.name[2]") },
          { name: this.$t("RateToReturn.menu.name[3]") },
          { name: this.$t("RateToReturn.menu.name[4]") },
          { name: this.$t("RateToReturn.menu.name[5]") },
          { name: this.$t("RateToReturn.menu.name[6]") },
        ],
      };
    },
    //사용자 지갑
    userWallets() {
      const obejct = _.mapValues(this.currencySettings, (coin) => {
        const wallet = this.walletByCoinName(coin.code) || {};
        const avail = {
          KRW: _.isObject(
            _.find(
              this.marketsByBaseCoinCode["KRW"],
              (market) => parseInt(market.coinId) === parseInt(coin.id)
            )
          ),
          BTC: _.isObject(
            _.find(
              this.marketsByBaseCoinCode["BTC"],
              (market) => parseInt(market.coinId) === parseInt(coin.id)
            )
          ),
          USDT: _.isObject(
            _.find(
              this.marketsByBaseCoinCode["USDT"],
              (market) => parseInt(market.coinId) === parseInt(coin.id)
            )
          ),
        };

        const pendCount = _.chain(this.marketsByCode)
          .filter((market, code) => {
            return parseInt(market.coinId) === parseInt(coin.id);
          })
          .sumBy((market) => {
            return _.get(this.pend, [market.id, "length"], 0);
          })
          .value();
        return {
          ...wallet,
          coin,
          avail,
          pendCount,
        };
      });
      return Object.values(obejct);
    },
    //자산내역 리스트 원본데이터
    filterWallet() {
      if (!this.userWallets.length) {
        return [];
      }

      let filterWallet = this.userWallets;
      if (this.haveCoin) {
        filterWallet = filterWallet.filter((asset) => {
          if (asset.total && asset.total != 0) return true;
          else return false;
        });
      }
      const btcIndex = filterWallet.findIndex(
        (asset) => asset.coin.code == "BTC"
      );
      if (btcIndex != -1) {
        const btc = filterWallet[btcIndex];
        filterWallet.splice(btcIndex, 1);
        filterWallet.unshift(btc);
      }

      const usdtIndex = filterWallet.findIndex(
        (asset) => asset.coin.code == "USDT"
      );
      if (usdtIndex != -1) {
        const usdt = filterWallet[usdtIndex];
        filterWallet.splice(usdtIndex, 1);
        filterWallet.unshift(usdt);
      }

      const wonIndex = filterWallet.findIndex(
        (asset) => asset.coin.code == "KRW"
      );
      if (wonIndex != -1) {
        const won = filterWallet[wonIndex];
        filterWallet.splice(wonIndex, 1);
        filterWallet.unshift(won);
      }

      /* 총 매수금액 = (보유수량 * 매수평균가)의 누적 */
      let all = 0;
      for (let i = 1; i < filterWallet.length; i++) {
        let item = filterWallet[i];
        let ownedCoinAmount = item.total;
        let ownedCoinAvgPrice = item.wAvgPrice;
        let ownedCoinCode = item.coin.code;
        // 상장폐지 코인은 market에 없음
        let findCode = _.find(
          Object.values(this.marketsByCode),
          (ele) => ele.dealCoinCode === ownedCoinCode
        );

        // 보유수량 or 매수평균가 undefined일 때 0으로 표현
        if (
          ownedCoinAmount == undefined ||
          ownedCoinAvgPrice == undefined ||
          findCode == undefined
        ) {
          ownedCoinAmount = 0;
          ownedCoinAvgPrice = 0;
        } else {
          ownedCoinAmount;
          ownedCoinAvgPrice;
        }
        item.sumBuyingPrice = ownedCoinAmount * ownedCoinAvgPrice;
        all += item.sumBuyingPrice;
        item.allPrice = all;
        this.totalBuyingPrice = item.allPrice;
      }
      // }
      // return !filterWallet.length;
      return filterWallet;
    },
    // 총 보유자산
    totalWallet() {
      if (this.filterWallet[0] && this.filterWallet[0].available) {
        return this.totalPriceProfiLosses + this.filterWallet[0].available;
      } else {
        return this.totalPriceProfiLosses;
      }
    },
    //주문 가능
    availableWallet() {
      return (
        this.stateWallet("available") +
        (this.walletByCoinName("KRW").available || 0)
      );
    },
  },
  methods: {
    ...mapMutations(["setSmallBalance"]),
    showToKRWPopup() {
      this.popupToKRW = true;
    },
    closeToKRWPopup() {
      this.popupToKRW = false;
    },
    //툴팁 open
    openBtn() {
      this.showTooltip = true;
    },
    //툴팁 close
    closeBtn() {
      this.showTooltip = false;
    },
    stateWallet(state) {
      try {
        return _.reduce(
          this.coinSettings,
          (sum, coin) => {
            const price =
              this.toKRW(this.$bnCode(coin.code)).price *
              this.walletByCoinName(coin.code)[state];
            const typeChx = typeof price !== "number" || !price ? 0 : price;
            return sum + typeChx;
          },
          0
        );
      } catch (e) {
        return 0;
      }
    },
    // wallet coin code와 market coin code 일치하는 오브젝트에서 뷰 활성화 확인하기
    checkOnViewEnable(code) {
      const findCode = _.find(
        Object.values(this.marketsByCode),
        (ele) => ele.dealCoinCode === code
      );
      if (findCode == undefined) {
        return true;
      } else {
        return false;
      }
    },
  },
  components: {
    TabMenu,
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/color_palette.scss";

body {
  ul {
    list-style: none;
  }
  p {
    margin-bottom: 0;
    color: #333;
  }
  .bottom {
    width: 100%;
    text-align: left;
  }
}
.container {
  color: #333 !important;
  .scrollX {
    overflow-x: scroll;
    height: 48px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
    .investList-menu {
      width: 454px;
      padding: 7px 12px;
      list-style: none;
      li {
        min-width: 88px;
        padding: 0 6px;
        margin-right: 8px;
        border: 1px solid #dcdfe3;
        border-radius: 52px;
        text-align: center;
        background-color: #fff;
        line-height: 32px;
        font-size: 12px;
        font-weight: normal;
        color: #333;
        &.active {
          border-color: #eb3246;
          background-color: #eb3246;
          color: #fff;
        }
      }
      a:last-child li {
        margin-right: 0;
      }
    }
  }
  .summary-wrap {
    padding: 15px;
    background-color: $BlueGray300;
    .top-content {
      .totalAsset {
        margin-bottom: 5px;
        .content {
          justify-content: space-between;
          .title {
            p {
              line-height: 18px;
              font-size: 16px;
              font-weight: bold;
              color: #333;
            }
          }
          .toKRW-noti {
            display: flex;
            align-items: center;
            position: relative;
            margin-left: 12px;
            &.show {
              .icon {
                background-image: url("../../assets/img/mypage/question-black.svg");
              }
              p {
                color: #333;
              }
            }
            .icon {
              width: 14px;
              height: 14px;
              margin-left: 5px;
              background-image: url("../../assets/img/mypage/question-gray.svg");
              background-repeat: no-repeat;
            }
            p {
              padding-left: 16px;
              font-size: 12px;
              font-weight: normal;
              color: #999;
            }
          }
        }
        .data {
          font-family: "Roboto";
          .txt-bold {
            font-size: 24px;
            font-weight: bold;
          }
          .txt-normal {
            margin-left: -4px;
            font-size: 12px;
            font-weight: normal;
          }
        }
      }
      .arrow-up {
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-bottom: 5px solid black;
      }
    }
    .summary-total {
      /* justify-content: space-between;
      margin-bottom: 4px; */
      .key,
      .value {
        font-size: 12px;
        line-height: 1.5;
        font-weight: normal;
        &.bold {
          font-weight: bold;
        }
        /* span.bold {
          font-weight: 500;
        } */
      }
      .value {
        font-family: "Roboto";
      }
      &:last-child {
        margin-bottom: 0;
      }
      &.krw {
        padding: 10px 20px;
        margin: 15px 0 0;
        background-color: $BlueGray400;
        border-radius: 20px;
      }
    }
    .bottom-content {
      margin-top: 15px;
      .summary-total {
        flex: 1;
        padding-left: 20px;
        &:last-of-type {
          border-left: 1px solid $BlueGray600;
        }
      }
    }
  }
  .detail-wrap {
    width: 100%;
    min-height: 450px;
    border-top: 1px solid #eef0f3;
    .smallballance-type01 {
      padding: 15px;
    }
    .list-wrap {
      clear: both;
      .list {
        &.hidden {
          display: none;
        }
      }
      div {
        .content-box {
          padding: 0 15px;
          font-size: 12px;
          border-top: 1px solid $BlueGray400;
          background-color: #ffffff;
          .detail-content {
            justify-content: space-between;
            padding: 10px 0;
            .left-content {
              flex: 1;
              position: relative;
              img.coin-symbol {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                width: 24px;
                height: 24px;
              }
              span {
                position: absolute;
                top: 50%;
                left: 28px;
                transform: translateY(-50%);
                width: 130px;
              }
              .icon-link {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
              }
            }
            .right-content {
              flex: 1;
              text-align: right;
            }
            .bottom-content {
              text-align: right;
              .summary-total {
                flex: 1;
                padding-left: 10px;
              }
            }
            &.top {
              border-bottom: 1px solid $BlueGray400;
            }
          }
          .summary-total {
            justify-content: space-between;
            font-size: 12px;
            line-height: 1.5;
            font-weight: normal;
            .key {
              color: $WarmBlack500;
            }
            .value {
              font-family: "Roboto";
            }
          }
        }
      }
    }
  }
}
</style>
